import { Box, LinearProgress, Stack, Typography, styled } from "~/common/mui";

interface Props {
  label?: string;
  variant?: "determinate" | "indeterminate";
  value?: number;
}

const BulkATCProgressBar = ({ label, value = 0, variant = "determinate" }: Props) => {
  return (
    <ContainerStack>
      <InnerContainerStack gap={2}>
        <Typography variant="titleLarge">{label}</Typography>
        <ProgressWrapper>
          <StyledLinearProgress value={value} variant={variant} aria-label={label} />
        </ProgressWrapper>
      </InnerContainerStack>
    </ContainerStack>
  );
};

const ContainerStack = styled(Stack)({
  alignItems: "center",
  justifyContent: "center",
  minHeight: "357px",
});

const InnerContainerStack = styled(Stack)({
  width: "100%",
  maxWidth: "360px",
  padding: "16px",
  alignItems: "center",
});

const ProgressWrapper = styled(Box)({
  width: "100%",
});

const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  backgroundColor: theme.palette.surfaceContainer.highest,
  borderRadius: "999px",
  "& .MuiLinearProgress-bar": {
    backgroundColor: theme.palette.primary.main,
    borderRadius: "999px",
    transition: "width 0.4s ease-in-out",
  },
}));

export default BulkATCProgressBar;
